export default "__VITE_ASSET__BuWvwl9L__"